<template>
  <div class="wrapper" v-on="inputListeners">
    <div class="fade" v-bind:class="{ 'fade-out': show, 'fade-in': !show }">
      <slot></slot>
    </div>
    <div class="operator" v-show="show">
      <slot name="operator"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OverlayOperator',
  data(){
    return {
      show: false
    }
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    inputListeners: function () {
      const vm = this

      if (vm.disabled) {
        return this.$listeners
      } else {
        return Object.assign({},
          this.$listeners,
          {
            mouseenter: function (e) {
              vm.show = true
            },
            mouseleave: function (e) {
              vm.show = false
            }
          }
        )
      }
    }
  }
}
</script>

<style scoped>
.operator {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.wrapper {
  position: relative;
}
.fade {
  transition: opacity 200ms ease-in-out;
}
.fade-out {
  opacity: 0.2;
}
.fade-in {
  opacity: 1;
}
</style>
